import { createPaths } from "@routes/utils";

import type { IExtractRouteParamMap } from "@routes";

const baseRoute = `/basic-info/item-category`;

export const itemCategoryRoutesObj = {
  list: baseRoute,
  create: `${baseRoute}/create`,
  edit: `${baseRoute}/edit/:categoryId`,
} as const;

export type IItemCategoryRouteParams = IExtractRouteParamMap<
  typeof itemCategoryRoutesObj
>;

export const itemCategoryPath = createPaths<
  typeof itemCategoryRoutesObj,
  IItemCategoryRouteParams
>(itemCategoryRoutesObj);
